// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dig8B","questions":"styles_questions__1jJbS","footer":"styles_footer__1ZPw9"};